// SECURED
export const SECURED_ROOT = '/secured';
export const SECURED__DASHBOARD = SECURED_ROOT + '/dashboard';

// WIZARD
export const SECURED__WIZARD = SECURED_ROOT + '/wizard';

// DISPLAY CONSENT
export const SECURED__CONSENT = SECURED_ROOT + '/consent';



